export default __webpack_public_path__ + "_/images/cup-table-727c88df38ef836a4f8166e383e438b0f87db454e6f424d8b287113917a7f77c.svg";